/* eslint-disable react/style-prop-object */
import React from 'react';
import { FormattedNumber } from 'react-intl';

import isNumber from 'lodash/isNumber';
import PropTypes from 'prop-types';

function PercentageField(props) {
  const { value, ...otherProps } = props;

  const number = Number(value);

  if (!Number.isNaN(number) && isNumber(number))
    return (
      <FormattedNumber value={value} style="percent" maximumFractionDigits={2} {...otherProps} />
    );

  return <>{value}</>;
}

PercentageField.propTypes = {
  value: PropTypes.any,
};

export default PercentageField;
